export function vehicleState(vehicle) {
  const trip = vehicle.active_trip;
  const status = vehicle.status;
  if (status === "inactive") return "inactive";
  if (status === "maintenance") return "maintenance";
  if (status === "parked") return "parked";
  if (status === "idle") return "idle";
  if (trip && trip.distance_remaining_km <= 0.5) return "arrived";
  if (vehicle.speed_kmh > 0.5) return "moving";
  if (trip) return "parked";
  return "idle";
}

export const STATE_META = {
  moving: { label: "ON TRIP", color: "#00FF66", cls: "moving" },
  parked: { label: "PARKED", color: "#FF3B30", cls: "parked" },
  arrived: { label: "ARRIVED", color: "#00F0FF", cls: "moving" },
  idle: { label: "IDLE", color: "#A1A1AA", cls: "idle" },
  maintenance: { label: "MAINTENANCE", color: "#FFCC00", cls: "idle" },
  inactive: { label: "INACTIVE", color: "#52525B", cls: "idle" },
};

export function fmtKm(v) {
  if (v === null || v === undefined) return "--";
  return Number(v).toFixed(1);
}

export function fmtCoords(loc) {
  if (!loc) return "NO FIX";
  return `${loc.lat.toFixed(4)}, ${loc.lng.toFixed(4)}`;
}

function parseUtc(iso) {
  if (!iso) return null;
  const hasTz = /(Z|[+-]\d{2}:?\d{2})$/.test(iso);
  return new Date(hasTz ? iso : `${iso}Z`);
}

export function sinceLabel(iso) {
  if (!iso) return "--";
  const ms = Date.now() - parseUtc(iso).getTime();
  if (ms < 0) return "0m";
  const mins = Math.floor(ms / 60000);
  if (mins < 60) return `${mins}m`;
  const hrs = Math.floor(mins / 60);
  if (hrs < 24) return `${hrs}h ${mins % 60}m`;
  return `${Math.floor(hrs / 24)}d ${hrs % 24}h`;
}

export function fmtEta(iso) {
  if (!iso) return "--:--";
  return parseUtc(iso).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false });
}

export function progressPct(trip) {
  if (!trip || !trip.planned_distance_km) return 0;
  return Math.max(0, Math.min(100, (trip.distance_covered_km / trip.planned_distance_km) * 100));
}
